import { render } from "./FieldInstruction.vue?vue&type=template&id=080a868b&scoped=true"
import script from "./FieldInstruction.vue?vue&type=script&lang=js"
export * from "./FieldInstruction.vue?vue&type=script&lang=js"

import "./FieldInstruction.vue?vue&type=style&index=0&id=080a868b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080a868b"]])

export default __exports__